export default __webpack_public_path__ + "static/media/android-logo.e2881842.svg";